<div class="stats-page">
    <!-- Main Summary Cards -->
    <div class="summary-cards">
        <div class="stat-card stat-card--blue">
            <div class="stat-card__icon">
                <i class="fa-solid fa-users"></i>
            </div>
            <div class="stat-card__content">
                <span class="stat-card__value">{{ getTotalLeads() | number }}</span>
                <span class="stat-card__label">Total Leads</span>
                <span class="stat-card__subtext">{{ getConversionRate() | number: '1.1-1' }}% conversion rate</span>
            </div>
        </div>
        <div class="stat-card stat-card--orange">
            <div class="stat-card__icon">
                <i class="fa-solid fa-hourglass-half"></i>
            </div>
            <div class="stat-card__content">
                <span class="stat-card__value">{{ getActivePipeline() | number }}</span>
                <span class="stat-card__label">Active Pipeline</span>
                <span class="stat-card__subtext">In-progress leads</span>
            </div>
        </div>
        <div class="stat-card stat-card--green">
            <div class="stat-card__icon">
                <i class="fa-solid fa-check-circle"></i>
            </div>
            <div class="stat-card__content">
                <span class="stat-card__value">{{ getConvertedLeads() | number }}</span>
                <span class="stat-card__label">Converted</span>
                <span class="stat-card__subtext">{{ getConversionRate() | number: '1.1-1' }}% conversion rate</span>
            </div>
        </div>
        <div class="stat-card stat-card--purple">
            <div class="stat-card__icon">
                <i class="fa-solid fa-chart-line"></i>
            </div>
            <div class="stat-card__content">
                <span class="stat-card__value">{{ getAvgDealSize() | number: '1.1-1' }}</span>
                <span class="stat-card__label">Avg Deal Size</span>
                <span class="stat-card__subtext">bays per conversion</span>
            </div>
        </div>
    </div>

    <!-- Secondary Stat Cards -->
    <div class="secondary-cards secondary-cards--8col">
        <div class="secondary-card">
            <i class="fa-solid fa-coins"></i>
            <div class="secondary-card__content">
                <span class="secondary-card__value">R{{ getTotalValue() | number: '1.0-0' }}</span>
                <span class="secondary-card__label">Total Value</span>
            </div>
        </div>
        <div class="secondary-card">
            <i class="fa-solid fa-car"></i>
            <div class="secondary-card__content">
                <span class="secondary-card__value">{{ getTotalBays() | number }}</span>
                <span class="secondary-card__label">Total Bays</span>
            </div>
        </div>
        <div class="secondary-card">
            <i class="fa-solid fa-file-contract"></i>
            <div class="secondary-card__content">
                <span class="secondary-card__value">{{ getNewSubscriptions() | number }}</span>
                <span class="secondary-card__label">New Subs</span>
            </div>
        </div>
        <div class="secondary-card">
            <i class="fa-solid fa-user-check"></i>
            <div class="secondary-card__content">
                <span class="secondary-card__value">{{ getRegisteredUsers() | number }}</span>
                <span class="secondary-card__label">Registered Users</span>
            </div>
        </div>
        <div class="secondary-card secondary-card--negative">
            <i class="fa-solid fa-user-slash"></i>
            <div class="secondary-card__content">
                <span class="secondary-card__value">{{ getNotAssignedLeads() | number }}</span>
                <span class="secondary-card__label">Not Assigned to a User</span>
            </div>
        </div>
        <div class="secondary-card secondary-card--negative">
            <i class="fa-solid fa-phone-slash"></i>
            <div class="secondary-card__content">
                <span class="secondary-card__value">{{ getNewStatusLeads() | number }}</span>
                <span class="secondary-card__label">Not Contacted</span>
            </div>
        </div>
        <div class="secondary-card secondary-card--negative">
            <i class="fa-solid fa-clock-rotate-left"></i>
            <div class="secondary-card__content">
                <span class="secondary-card__value">{{ getAgingLeads() | number }}</span>
                <span class="secondary-card__label">Older Than 2 Weeks</span>
            </div>
        </div>
        <div class="secondary-card secondary-card--negative">
            <i class="fa-solid fa-circle-xmark"></i>
            <div class="secondary-card__content">
                <span class="secondary-card__value">{{ getClosedLeads() | number }}</span>
                <span class="secondary-card__label">Did Not Convert</span>
            </div>
        </div>
    </div>

    <!-- Chart Blocks Grid -->
    <div class="stat-blocks-grid">
        <!-- Status -->
        <div class="stat-block">
            <div class="stat-block__header">
                <div class="stat-block__title">
                    <i class="fa-solid fa-chart-pie"></i>
                    <h3>Status</h3>
                </div>
                <div class="stat-block__tabs">
                    <button [class.active]="activeTabs.status === 'leads'" (click)="switchTab('status', 'leads')">Leads</button>
                    <button [class.active]="activeTabs.status === 'value'" (click)="switchTab('status', 'value')">Value</button>
                    <button [class.active]="activeTabs.status === 'bays'" (click)="switchTab('status', 'bays')">Bays</button>
                </div>
            </div>
            <div class="stat-block__body" *ngIf="statusChart.series.length > 0">
                <apx-chart
                    [series]="statusChart.series"
                    [chart]="chartConfig"
                    [plotOptions]="{ bar: { horizontal: true, barHeight: '60%', distributed: true, borderRadius: 4 } }"
                    [xaxis]="{ categories: statusChart.categories }"
                    [colors]="statusChart.colors || defaultColors"
                    [dataLabels]="dataLabels"
                    [legend]="{ show: false }"
                ></apx-chart>
            </div>
        </div>

        <!-- Location -->
        <div class="stat-block">
            <div class="stat-block__header">
                <div class="stat-block__title">
                    <i class="fa-solid fa-location-dot"></i>
                    <h3>Location</h3>
                </div>
                <div class="stat-block__tabs">
                    <button [class.active]="activeTabs.location === 'leads'" (click)="switchTab('location', 'leads')">Leads</button>
                    <button [class.active]="activeTabs.location === 'value'" (click)="switchTab('location', 'value')">Value</button>
                    <button [class.active]="activeTabs.location === 'bays'" (click)="switchTab('location', 'bays')">Bays</button>
                </div>
            </div>
            <div class="stat-block__body" *ngIf="locationChart.series.length > 0">
                <apx-chart
                    [series]="locationChart.series"
                    [chart]="chartConfig"
                    [plotOptions]="{ bar: { horizontal: true, barHeight: '60%', distributed: true, borderRadius: 4 } }"
                    [xaxis]="{ categories: locationChart.categories }"
                    [colors]="locationChart.colors || defaultColors"
                    [dataLabels]="dataLabels"
                    [legend]="{ show: false }"
                ></apx-chart>
            </div>
        </div>

        <!-- Source -->
        <div class="stat-block">
            <div class="stat-block__header">
                <div class="stat-block__title">
                    <i class="fa-solid fa-globe"></i>
                    <h3>Source</h3>
                </div>
                <div class="stat-block__tabs">
                    <button [class.active]="activeTabs.source === 'leads'" (click)="switchTab('source', 'leads')">Leads</button>
                    <button [class.active]="activeTabs.source === 'value'" (click)="switchTab('source', 'value')">Value</button>
                    <button [class.active]="activeTabs.source === 'bays'" (click)="switchTab('source', 'bays')">Bays</button>
                </div>
            </div>
            <div class="stat-block__body" *ngIf="sourceChart.series.length > 0">
                <apx-chart
                    [series]="sourceChart.series"
                    [chart]="chartConfig"
                    [plotOptions]="{ bar: { horizontal: true, barHeight: '60%', distributed: true, borderRadius: 4 } }"
                    [xaxis]="{ categories: sourceChart.categories }"
                    [colors]="sourceChart.colors || defaultColors"
                    [dataLabels]="dataLabels"
                    [legend]="{ show: false }"
                ></apx-chart>
            </div>
        </div>

        <!-- Assignee -->
        <div class="stat-block">
            <div class="stat-block__header">
                <div class="stat-block__title">
                    <i class="fa-solid fa-user-check"></i>
                    <h3>Assignee</h3>
                </div>
                <div class="stat-block__tabs">
                    <button [class.active]="activeTabs.assignee === 'leads'" (click)="switchTab('assignee', 'leads')">Leads</button>
                    <button [class.active]="activeTabs.assignee === 'value'" (click)="switchTab('assignee', 'value')">Value</button>
                    <button [class.active]="activeTabs.assignee === 'bays'" (click)="switchTab('assignee', 'bays')">Bays</button>
                </div>
            </div>
            <div class="stat-block__body" *ngIf="assigneeChart.series.length > 0">
                <apx-chart
                    [series]="assigneeChart.series"
                    [chart]="chartConfig"
                    [plotOptions]="{ bar: { horizontal: true, barHeight: '60%', distributed: true, borderRadius: 4 } }"
                    [xaxis]="{ categories: assigneeChart.categories }"
                    [colors]="assigneeChart.colors || defaultColors"
                    [dataLabels]="dataLabels"
                    [legend]="{ show: false }"
                ></apx-chart>
            </div>
        </div>

        <!-- Campaign -->
        <div class="stat-block">
            <div class="stat-block__header">
                <div class="stat-block__title">
                    <i class="fa-solid fa-bullhorn"></i>
                    <h3>Campaign</h3>
                </div>
                <div class="stat-block__tabs">
                    <button [class.active]="activeTabs.campaign === 'leads'" (click)="switchTab('campaign', 'leads')">Leads</button>
                    <button [class.active]="activeTabs.campaign === 'value'" (click)="switchTab('campaign', 'value')">Value</button>
                    <button [class.active]="activeTabs.campaign === 'bays'" (click)="switchTab('campaign', 'bays')">Bays</button>
                </div>
            </div>
            <div class="stat-block__body" *ngIf="campaignChart.series.length > 0">
                <apx-chart
                    [series]="campaignChart.series"
                    [chart]="chartConfig"
                    [plotOptions]="{ bar: { horizontal: true, barHeight: '60%', distributed: true, borderRadius: 4 } }"
                    [xaxis]="{ categories: campaignChart.categories }"
                    [colors]="campaignChart.colors || defaultColors"
                    [dataLabels]="dataLabels"
                    [legend]="{ show: false }"
                ></apx-chart>
            </div>
        </div>

        <!-- Close Reasons -->
        <div class="stat-block">
            <div class="stat-block__header">
                <div class="stat-block__title">
                    <i class="fa-solid fa-circle-xmark"></i>
                    <h3>Close Reasons</h3>
                </div>
                <div class="stat-block__tabs">
                    <button [class.active]="activeTabs.closedReason === 'leads'" (click)="switchTab('closedReason', 'leads')">Leads</button>
                    <button [class.active]="activeTabs.closedReason === 'value'" (click)="switchTab('closedReason', 'value')">Value</button>
                    <button [class.active]="activeTabs.closedReason === 'bays'" (click)="switchTab('closedReason', 'bays')">Bays</button>
                </div>
            </div>
            <div class="stat-block__body" *ngIf="closedReasonChart.series.length > 0">
                <apx-chart
                    [series]="closedReasonChart.series"
                    [chart]="chartConfig"
                    [plotOptions]="{ bar: { horizontal: true, barHeight: '60%', distributed: true, borderRadius: 4 } }"
                    [xaxis]="{ categories: closedReasonChart.categories }"
                    [colors]="closedReasonChart.colors || ['#ef4444']"
                    [dataLabels]="dataLabels"
                    [legend]="{ show: false }"
                ></apx-chart>
            </div>
        </div>

        <!-- Lead Aging -->
        <div class="stat-block">
            <div class="stat-block__header">
                <div class="stat-block__title">
                    <i class="fa-solid fa-clock-rotate-left"></i>
                    <h3>Lead Aging</h3>
                </div>
            </div>
            <div class="stat-block__body" *ngIf="agingChart.series.length > 0">
                <apx-chart
                    [series]="agingChart.series"
                    [chart]="chartConfig"
                    [plotOptions]="{ bar: { horizontal: true, barHeight: '60%', distributed: true, borderRadius: 4 } }"
                    [xaxis]="{ categories: agingChart.categories }"
                    [colors]="agingChart.colors || defaultColors"
                    [dataLabels]="dataLabels"
                    [legend]="{ show: false }"
                ></apx-chart>
            </div>
        </div>
    </div>
</div>
